import {RootState} from '../../../store';
import {
  getFilePdf,
  getInclusions,
  getInclusionSummary,
  setInclusionsUsersSetting,
  updateInclusionMakerReaded
} from '../actions/InclusionActions';
import {connect, ConnectedProps} from 'react-redux';
import {withRouter} from 'react-router-dom';
import InclusionComponent from '../components/InclusionComponent';
import {IInclusionsSummary, IUserSettings} from '../reducers/inclusionsReducers';

const mapStateToProps = (state: RootState) => {
  return {
    isLogged: state.authReducer.isLogged,
    user: state.authReducer.user,
    inclusionsSummary: state.inclusionsReducers?.inclusionsSummary as IInclusionsSummary,
    inclusions: state.inclusionsReducers?.inclusions,
    userSettings: state.inclusionsReducers?.userSettings as IUserSettings
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getInclusionsSummary: (patientId: number | null) => {
      console.log(`will return promise with patientId ${patientId}`)
      return new Promise((resolve, reject) => {
        console.log(`will dispatch getSummary`)
        dispatch(getInclusionSummary(patientId, resolve, reject))
      })
    },
    getInclusions: (limit: number,
                    page: number,
                    read: boolean,
                    patientId: number | null) => {
      return new Promise((resolve, reject) => {
        dispatch( getInclusions(limit, page, read, patientId, resolve, reject))
      })
    },
    getFilePdf: (fileId: number | null) => {
      return new Promise((resolve: (pdf: Blob) => void, reject: any) => {
        if (fileId) {
          dispatch(getFilePdf(fileId, resolve, reject))
        }
      })
    },
    setUserSettings: (settings: IUserSettings) => {
      dispatch(setInclusionsUsersSetting(settings))
    },
    updateInclusionMakerReaded: (implantEnrollmentId: string) => {
      console.log(`container implantEnrollmentId ${implantEnrollmentId}`)
      return new Promise((resolve, reject) => {
        dispatch(
            updateInclusionMakerReaded(
                implantEnrollmentId,true, resolve, reject
            )
        )
      })
    }
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps)

export type PropsFromReduxInclusions = ConnectedProps<typeof connector>& {
  patientId?: number
  forceReload?: boolean
}

export default withRouter(connector(InclusionComponent) as any) as any as (props: {
  patientId?: number
  forceReload?: boolean
}) => JSX.Element
